import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import type { ReactNode } from 'react'

type Ton = 'succes' | 'erreur' | 'info'

interface Toast {
  id: number
  message: string
  ton: Ton
}

const ContexteToasts = createContext<((message: string, ton?: Ton) => void) | null>(null)

export function FournisseurToasts({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([])

  const ajouter = useCallback((message: string, ton: Ton = 'info') => {
    const id = Date.now() + Math.random()
    setToasts((precedents) => [...precedents, { id, message, ton }])
    window.setTimeout(() => {
      setToasts((precedents) => precedents.filter((t) => t.id !== id))
    }, 5000)
  }, [])

  const valeur = useMemo(() => ajouter, [ajouter])

  return (
    <ContexteToasts.Provider value={valeur}>
      {children}
      {/* aria-live polite : annoncé sans interrompre la lecture en cours. */}
      <div
        className="pointer-events-none fixed bottom-4 right-4 z-50 flex w-80 flex-col gap-2"
        aria-live="polite"
        aria-atomic="false"
      >
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`pointer-events-auto rounded-lg px-4 py-3 text-sm shadow-lg ring-1 ring-black/5 ${
              t.ton === 'succes'
                ? 'bg-emerald-600 text-white'
                : t.ton === 'erreur'
                  ? 'bg-red-600 text-white'
                  : 'bg-slate-800 text-white'
            }`}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ContexteToasts.Provider>
  )
}

// Le crochet vit a cote de son fournisseur : les separer imposerait un
// troisieme fichier pour le contexte, sans rien gagner.
// eslint-disable-next-line react-refresh/only-export-components
export function useToast() {
  const contexte = useContext(ContexteToasts)
  if (!contexte) throw new Error('useToast doit être utilisé dans un FournisseurToasts.')
  return contexte
}
